import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 获取保养部位列表
 */
export function getMaintainLocationList(data) {
  return fetch ({
    url: '/maintain/maintain/location/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 添加单位
 */
export function addLocation(data) {
  return fetch({
    url: '/maintain/maintain/location/save',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 编辑单位
 */
export function editLocation(data) {
  return fetch({
    url: '/auth/unit/edit',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除单位
 */
export function deleteLocation(data) {
  return fetch({
    url: '/maintain/maintain/location/delete',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 导出单位
 */
export function exportUnit(data) {
  return formAxios({
    url: '/auth/unit/exportUnitList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取部门列表
 */
export function getDepartmentTree(params) {
  return fetch ({
    url: '/auth/department/getDepartmentTree',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 编辑部门
 */
export function editDepartment(data) {
  return fetch({
    url: '/auth/department/save',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 删除部门
 */
export function deleteDepartment(data) {
  return fetch({
    url: '/auth/department/delete',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 根据部门id获取项目
 */
export function getProjectIdByDepartment(data) {
  return fetch({
    url: '/auth/department/getProjectIdByDepartment',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 根据unitId和部门id获取项目
 */
export function getProjectLiftTree(params) {
  return fetch({
    url: '/maintain/project/projectLiftTree',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} params
 * 根据部门id获取部门详情
 */
export function getDepartmentDetail(params) {
  return fetch({
    url: '/auth/department/detail',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} params
 * 根据部门id获取部门详情
 */
export function exportLocation(params) {
  return fetch({
    url: '/auth/department/detail',
    method: 'GET',
    params
  })
}




// WEBPACK FOOTER //
// ./src/api/MaintenanceLocation/index.js